<!--  -->
<template>
    <div>
        <h3>
           {{isEnglish ? 'contact number':'联系电话'}}： <a :href="'tel:'+tourInfo.settings.phone">
            {{tourInfo.settings.phone}}
            </a>
        </h3>
        
    </div>
</template>
<script>
export default {
    data() {
        return {
            tourInfo:{},
            isEnglish:false
        }
    },
    created() {
        this.tourInfo=JSON.parse(localStorage.getItem("tourInfo"))
        this.isEnglish=this.$route.query.isEnglish
    },
    mounted() {}
}
</script>
<style scoped lang="scss">
div{
    padding: .3rem;
    box-sizing: border-box;
}
    h3{
        font-size: 20px;
        a{
            color: orange;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/tourKefu.vue